import React from 'react'
import { Autocomplete, Box, TextField } from '@mui/material'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import styles from './styles/PopUpTopPage.module.css'
import { ChevronBottomIcon, TickIcon } from '~/assets/icons'
import { useThemeContext } from '~/theme/ThemeProvider'
const cx = classNames.bind(styles)

// Component dùng chung trong FormRoomHotel
const InputSelect = ({ options, itemSelected, onChange, placeholder, error, name }) => {
  const { currentThemeObject } = useThemeContext()
  const { t } = useTranslation()

  // Hàm hiển thị từng option của droplist
  const renderOption = (props, option) => {
    const active = option.value === itemSelected?.value

    return (
      <Box
        key={option.value}
        className={cx('droplist_item_wrapper')}
        padding="0 4px"
        sx={{
          backgroundColor: active ? 'baseColor.color11' : 'transparent',
          '&:hover': {
            backgroundColor: 'baseColor.color14',
          },
        }}>
        <Box {...props} className={cx('droplist_item')}>
          {option.label}
          {active && (
            <Box className={cx('tick_icon')}>
              <TickIcon color={currentThemeObject.color15} />
            </Box>
          )}
        </Box>
      </Box>
    )
  }

  const renderNoResultText = () => {
    return (
      <Box textAlign="center" fontWeight="600" color="#000">
        {t('placeholder.no_results')}
      </Box>
    )
  }

  return (
    <Box>
      <Autocomplete
        disableClearable
        componentsProps={{
          paper: {
            className: cx('box_paper_droplist'),
            sx: {
              backgroundColor: 'baseColor.color13',
            },
          },
        }}
        ListboxProps={{
          className: cx('box_options'),
        }}
        renderOption={renderOption}
        options={options}
        value={itemSelected}
        popupIcon={
          <Box display="flex" marginTop="5px">
            <ChevronBottomIcon color={itemSelected?.value ? '#000' : 'rgba(0, 0, 0, 0.35)'} />
          </Box>
        }
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              backgroundColor: itemSelected?.value ? 'baseColor.color11' : 'baseColor.color13',
              borderRadius: '8px',
            }}
            InputProps={{
              ...params.InputProps,
              className: cx('input_select_wrapper'),
            }}
            inputProps={{
              ...params.inputProps,
              className: cx('input_select'),
              // Do deploy lên product thì bị css của MUI override lại nên mới phải css inline
              style: { padding: 0, fontWeight: '600', fontSize: '1.6rem', color: '#000' },
            }}
            focused={false}
            label=""
            fullWidth
            placeholder={placeholder}
            name={name}
          />
        )}
        onChange={onChange}
        noOptionsText={renderNoResultText()}
      />
      <Box fontSize="1.2rem" color="red" minHeight="10px">
        {error}
      </Box>
    </Box>
  )
}

InputSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  itemSelected: PropTypes.object,
  placeholder: PropTypes.string,
  error: PropTypes.node,
  name: PropTypes.string,
}

export default React.memo(InputSelect)
